import { motion } from "framer-motion";

const variants = {
  hidden: { opacity: 0, y: 40 },
  visible: (i = 0) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.8, ease: [0.16, 1, 0.3, 1], delay: i * 0.08 },
  }),
};

export const Reveal = ({ children, i = 0, className = "", as = "div", ...rest }) => {
  const MotionTag = motion[as] || motion.div;
  return (
    <MotionTag
      className={className}
      variants={variants}
      custom={i}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, margin: "-80px" }}
      {...rest}
    >
      {children}
    </MotionTag>
  );
};

export const Eyebrow = ({ children, className = "" }) => (
  <span
    className={`inline-block text-xs uppercase tracking-[0.28em] text-[#c4a962] ${className}`}
  >
    {children}
  </span>
);
